import { render } from "./ModalImputazioneVoce.vue?vue&type=template&id=ab10fcbe"
import script from "./ModalImputazioneVoce.vue?vue&type=script&lang=js"
export * from "./ModalImputazioneVoce.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__